import { createStore } from 'vuex'
import auth from './modules/auth'
import companies from './modules/companies'
import dashboard from './modules/dashboard'
import kpis from './modules/kpis'

export default createStore({
  modules: {
    auth,
    companies,
    dashboard,
    kpis
  },
  state: {
    loading: false,
    snackbar: {
      show: false,
      message: '',
      color: 'success'
    }
  },
  mutations: {
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_SNACKBAR (state, { show, message, color = 'success' }) {
      state.snackbar = { show, message, color }
    }
  },
  actions: {
    showSnackbar ({ commit }, { message, color = 'success' }) {
      commit('SET_SNACKBAR', { show: true, message, color })
    },
    hideSnackbar ({ commit }) {
      commit('SET_SNACKBAR', { show: false, message: '', color: 'success' })
    }
  }
})